(function () {

  /* =========================================================
     ARROW NAVIGATION
     ========================================================= */

  document.addEventListener("click", function (event) {

    const prevButton = event.target.closest("[data-custom-cart-upsell-prev]");
    const nextButton = event.target.closest("[data-custom-cart-upsell-next]");

    if (!prevButton && !nextButton) {
      return;
    }

    const upsell = event.target.closest("[data-custom-cart-upsell]");

    if (!upsell) {
      return;
    }

    const viewport = upsell.querySelector(
      "[data-custom-cart-upsell-viewport]"
    );

    const product = upsell.querySelector(
      ".custom-cart-upsell__product"
    );

    if (!viewport || !product) {
      return;
    }

    const productWidth = product.getBoundingClientRect().width;

    viewport.scrollBy({
      left: nextButton ? productWidth : -productWidth,
      behavior: "smooth"
    });

  });


  /* =========================================================
     MOBILE TOUCH / SWIPE
     ========================================================= */

  function initialiseUpsellSwipe(viewport) {

    if (viewport.dataset.swipeInitialised === "true") {
      return;
    }

    viewport.dataset.swipeInitialised = "true";

    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;

    let direction = null;
    let hasDragged = false;


    viewport.addEventListener(
      "touchstart",
      function (event) {

        if (event.touches.length !== 1) {
          return;
        }

        const touch = event.touches[0];

        startX = touch.clientX;
        startY = touch.clientY;

        startScrollLeft = viewport.scrollLeft;

        direction = null;
        hasDragged = false;

        /*
         * Stop Beyond's document-level SwipeListener
         * from receiving touches that begin in our slider.
         */
        event.stopPropagation();

      },
      {
        passive: true
      }
    );


    viewport.addEventListener(
      "touchmove",
      function (event) {

        if (event.touches.length !== 1) {
          return;
        }

        const touch = event.touches[0];

        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;


        /*
         * Don't decide horizontal vs vertical immediately.
         * This prevents tiny finger movements from causing
         * accidental horizontal scrolling.
         */

        if (!direction) {

          if (
            Math.abs(deltaX) < 6 &&
            Math.abs(deltaY) < 6
          ) {
            event.stopPropagation();
            return;
          }

          direction =
            Math.abs(deltaX) > Math.abs(deltaY)
              ? "horizontal"
              : "vertical";
        }


        /*
         * Always keep this gesture away from Beyond's
         * global drawer swipe listener.
         */

        event.stopPropagation();


        /*
         * Horizontal movement:
         * We control the carousel ourselves.
         */

        if (direction === "horizontal") {

          hasDragged = true;

          event.preventDefault();

          viewport.scrollLeft =
            startScrollLeft - deltaX;

        }

        /*
         * Vertical movement:
         * Don't preventDefault().
         *
         * This means the customer can still naturally
         * scroll the cart drawer vertically while their
         * finger happens to be over the upsell.
         */

      },
      {
        passive: false
      }
    );


    viewport.addEventListener(
  "touchend",
  function (event) {

    event.stopPropagation();

    if (direction !== "horizontal") {
      direction = null;
      return;
    }


    const product = viewport.querySelector(
      ".custom-cart-upsell__product"
    );

    if (!product) {
      direction = null;
      return;
    }


    const productWidth =
      product.getBoundingClientRect().width;


    const endTouch = event.changedTouches[0];

    const totalSwipe =
      endTouch.clientX - startX;


    /*
     * Swipe sensitivity.
     *
     * Lower number = easier to trigger.
     */
    const swipeThreshold = 20;


    let destination = startScrollLeft;


    if (totalSwipe <= -swipeThreshold) {

      /*
       * Swipe left
       * Move forward one product.
       */

      destination =
        startScrollLeft + productWidth;

    } else if (totalSwipe >= swipeThreshold) {

      /*
       * Swipe right
       * Move backward one product.
       */

      destination =
        startScrollLeft - productWidth;

    } else {

      /*
       * Not enough movement for a swipe.
       * Return to the product we started on.
       */

      destination =
        Math.round(startScrollLeft / productWidth) *
        productWidth;

    }


    /*
     * Keep destination inside the slider.
     */

    const maxScroll =
      viewport.scrollWidth - viewport.clientWidth;


    destination = Math.max(
      0,
      Math.min(destination, maxScroll)
    );


    viewport.scrollTo({
      left: destination,
      behavior: "smooth"
    });


    setTimeout(function () {
      hasDragged = false;
    }, 150);


    direction = null;

  },
  {
    passive: true
  }
);

    viewport.addEventListener(
      "touchcancel",
      function (event) {

        event.stopPropagation();

        direction = null;

        setTimeout(function () {
          hasDragged = false;
        }, 100);

      },
      {
        passive: true
      }
    );


    /* =========================================================
       PREVENT ACCIDENTAL LINK CLICKS AFTER SWIPE
       ========================================================= */

    viewport.addEventListener(
      "click",
      function (event) {

        if (!hasDragged) {
          return;
        }

        const link = event.target.closest("a");

        if (link) {
          event.preventDefault();
          event.stopPropagation();
        }

      },
      true
    );

  }


  /* =========================================================
     INITIALISE EXISTING + AJAX-REFRESHED SLIDERS
     ========================================================= */

  function initialiseAllUpsells() {

    document
      .querySelectorAll("[data-custom-cart-upsell-viewport]")
      .forEach(function (viewport) {
        initialiseUpsellSwipe(viewport);
      });

  }


  /*
   * Initial page load
   */

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initialiseAllUpsells
    );

  } else {

    initialiseAllUpsells();

  }


  /*
   * Beyond replaces our upsell HTML after cart updates,
   * so watch for newly inserted sliders and initialise them.
   */

  const observer = new MutationObserver(function () {
    initialiseAllUpsells();
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();